import React, { PureComponent } from 'react';
import styled from 'styled-components';
import UpdatedDate from './UpdatedDate';
import InfoTooltip from './InfoTooltip';

const StyledKPIComponent = styled.div`
  position: relative;
  padding: 20px 20px 35px 20px;
  border-radius: 5px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(38, 47, 51, 0.3);
  grid-column: span 12;
  @media (min-width: 1024px) {
    grid-column: span ${props => props.columns};
  }
`;

const KPINumber = styled.div`
  font-size: 30px;
  line-height: 48px;
  font-family: latoregular;
  color: #42515a;
`;

const KPIChange = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 31px 20px;
  text-align: right;
`;

const KPIChangeNumber = styled.div`
  font-size: 14px;
  line-height: 14px;
  font-family: latoregular;
  color: #42515a;
  display: inline-block;
`;

const KPIChangeText = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: #42515a;
`;

const KPITitle = styled.div`
  grid-column: span 2;
  font-size: 14px;
  line-height: 14px;
  color: #42515a;
`;

class KPIComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: null
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (!props.isMissing && props.data !== state.data) {
      return {
        data: JSON.parse(props.data)
      };
    }
    return null;
  }

  render() {
    let changeNumber = this.state.data.change;
    let posColor = '#d0e385'; // normally green
    let negColor = '#fd91a9'; // normally red
    // For some it KPIs the semantically correct color coding might be
    // inverse for some KPIs. E.g. Kündigerquote
    if (typeof this.state.data.desired !== 'undefined') {
      if (this.state.data.desired === 'negative') {
        posColor = '#fd91a9';
        negColor = '#d0e385';
      }
    }

    return (
      <StyledKPIComponent columns={this.props.columns}>
        <KPINumber>{this.state.data.kpi || this.props.missingText}</KPINumber>
        <KPIChange>
          <KPIChangeNumber>
            <span
              style={{
                backgroundColor:
                  changeNumber.charAt(0) === '-'
                    ? negColor
                    : changeNumber.charAt(0) === '+'
                      ? posColor
                      : '',
                transition: 'all .3s ease',
                borderRadius: '5px',
                padding: '3px 8px'
              }}
            >
              {changeNumber || this.props.missingText}
            </span>
          </KPIChangeNumber>
          <KPIChangeText>
            {this.state.data.comptext || this.props.missingText}
          </KPIChangeText>
        </KPIChange>
        <KPITitle>
          {this.props.title}
          {this.props.info && (
            <InfoTooltip
              text={this.props.info}
              iconColor={`#a3a5a7`}
              iconWidth={`16px`}
              iconHeight={`16px`}
            />
          )}
        </KPITitle>
        <UpdatedDate>{`letztes Update: ${this.props.lastUpdated}`}</UpdatedDate>
      </StyledKPIComponent>
    );
  }
}

export default KPIComponent;
